import React from 'react';
import { Title, Text, Paper, TextInput, Table, Button, Badge, Progress, Group } from '@mantine/core';
import { Megaphone, Search, Plus, Filter } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function CampaignsPage() {
  const navigate = useNavigate();
  const campaigns = [{
    id: 1,
    name: 'Promoção de Maio',
    sent: 150,
    total: 150,
    status: 'Concluída',
    date: 'Hoje, 09:00',
    progress: 100
  }, {
    id: 2,
    name: 'Novos Produtos',
    sent: 45,
    total: 75,
    status: 'Em andamento',
    date: 'Ontem, 14:30',
    progress: 60
  }, {
    id: 3,
    name: 'Lembrete de Evento',
    sent: 0,
    total: 45,
    status: 'Agendada',
    date: 'Amanhã, 10:00',
    progress: 0
  }, {
    id: 4,
    name: 'Pesquisa de Satisfação',
    sent: 120,
    total: 120,
    status: 'Concluída',
    date: '22/05/2023, 11:15',
    progress: 100
  }, {
    id: 5,
    name: 'Desconto Especial',
    sent: 0,
    total: 200,
    status: 'Agendada',
    date: '25/05/2023, 09:00',
    progress: 0
  }];
  return <div className="space-y-6" data-id="element-252">
      <div className="flex justify-between items-center" data-id="element-253">
        <div data-id="element-254">
          <Title order={2} className="text-primary" data-id="element-255">
            Campanhas
          </Title>
          <Text c="dimmed" data-id="element-256">Gerencie suas campanhas de mensagens</Text>
        </div>
        <Button leftSection={<Plus size={18} data-id="element-258" />} radius="lg" onClick={() => navigate('/campaigns/create')} styles={{
        root: {
          backgroundColor: '#0047AB',
          height: '48px',
          '&:hover': {
            backgroundColor: '#003d91'
          }
        }
      }} data-id="element-257">
          Nova Campanha
        </Button>
      </div>
      <Paper radius="lg" p="md" withBorder data-id="element-259">
        <Group justify="space-between" mb="md" data-id="element-260">
          <TextInput placeholder="Buscar campanhas..." leftSection={<Search size={18} data-id="element-262" />} className="w-full max-w-md" data-id="element-261" />
          <Button leftSection={<Filter size={18} data-id="element-264" />} radius="lg" styles={{
          root: {
            backgroundColor: 'transparent',
            border: '1px solid #0047AB',
            color: '#0047AB',
            height: '48px',
            '&:hover': {
              backgroundColor: '#E3F2FD'
            }
          }
        }} data-id="element-263">
            Filtrar
          </Button>
        </Group>
        <Table highlightOnHover data-id="element-265">
          <Table.Thead data-id="element-266">
            <Table.Tr data-id="element-267">
              <Table.Th data-id="element-268">Nome</Table.Th>
              <Table.Th data-id="element-269">Progresso</Table.Th>
              <Table.Th data-id="element-270">Status</Table.Th>
              <Table.Th data-id="element-271">Data</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody data-id="element-272">
            {campaigns.map(campaign => <Table.Tr key={campaign.id} className="cursor-pointer hover:bg-gray-50" onClick={() => navigate(`/campaigns/${campaign.id}`)} data-id="element-273">
                <Table.Td data-id="element-274">
                  <Group data-id="element-275">
                    <div className="flex items-center justify-center rounded-full w-8 h-8" style={{
                  backgroundColor: '#E8F5E9',
                  color: '#00A86B'
                }} data-id="element-276">
                      <Megaphone size={16} data-id="element-277" />
                    </div>
                    <div data-id="element-278">
                      <Text fw={500} data-id="element-279">{campaign.name}</Text>
                      <Text size="xs" c="dimmed" data-id="element-280">
                        {campaign.sent} de {campaign.total} mensagens
                      </Text>
                    </div>
                  </Group>
                </Table.Td>
                <Table.Td style={{
              width: '30%'
            }} data-id="element-281">
                  <Progress value={campaign.progress} color={campaign.status === 'Concluída' ? 'green' : campaign.status === 'Em andamento' ? 'yellow' : 'blue'} size="sm" radius="xl" data-id="element-282" />
                </Table.Td>
                <Table.Td data-id="element-283">
                  <Badge color={campaign.status === 'Concluída' ? 'green' : campaign.status === 'Em andamento' ? 'yellow' : 'blue'} variant="light" data-id="element-284">
                    {campaign.status}
                  </Badge>
                </Table.Td>
                <Table.Td data-id="element-285">
                  <Text size="sm" data-id="element-286">{campaign.date}</Text>
                </Table.Td>
              </Table.Tr>)}
          </Table.Tbody>
        </Table>
      </Paper>
    </div>;
}